var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBasepackImpactedAgileOr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 140,
    viewBox: "0 0 233 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4355_8057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 233,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_4355_8057_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0 5C0 2.23857 2.23858 0 5 0H228C230.761 0 233 2.23858 233 5V135C233 137.761 230.761 140 228 140H5C2.23857 140 0 137.761 0 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4355_8057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.5 50.125C156.486 50.125 133.329 126.553 126 151.5L134.206 224H393V10C310.967 10 307.742 99.4013 259.697 99.4013C211.651 99.4013 219.516 50.125 184.5 50.125Z",
    fill: "url(#paint0_radial_4355_8057)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.875 51.5685H426.268V50.1606H114.875V51.5685ZM426.268 81H114.875V79.5921H426.268V81ZM426.268 111H114.875V109.592H426.268V111ZM426.268 171H114.875V169.592H426.268V171ZM114.875 141H426.268V139.592H114.875V141Z",
    fill: "url(#paint1_linear_4355_8057)",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4355_8057_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H228C230.761 0 233 2.23858 233 5V135C233 137.761 230.761 140 228 140H5C2.23857 140 0 137.761 0 135V5Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4355_8057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174.286 42.9999) rotate(63.7353) scale(201.838 261.215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB190",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB190",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4355_8057",
    x1: 326.999,
    y1: 162.699,
    x2: 141.566,
    y2: 51.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB190",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBasepackImpactedAgileOr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/basepackImpacted_agileOr.3932998a41431bbe7bcef030d1a5b508.svg";